<template>
  <div v-if="!reset">
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Hasło"
        v-model="password"
        class="w-full mt-6"/>
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <div class="my-2">
      <a class="cursor-pointer" @click="reset = true">forgot password?</a>
    </div>
    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Pamiętaj mnie</vs-checkbox>
      <!--            <router-link to="/pages/forgot-password">Nie pamiętasz hasła?</router-link>-->
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
  <div v-else>
    <div class="my-2">
      <p>wyślij resetującą wiadomość e-mail </p>
    </div>

    <div class="my-2">
      <vs-input
          v-validate="'required|email|min:3'"
          data-vv-validate-on="blur"
          name="email"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          placeholder="email"
          v-model="email"
          class="w-full"/>
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
    </div>

    <div class="flex flex-wrap justify-center my-4">
      <vs-button class="w-full" :disabled="!validateResetForm" @click="sendResetEmail">wysłać</vs-button>
    </div>
    <div class="my-4 text-center">
      <p>Wróć do strony logowania
        <a class="text-success cursor-pointer" @click="reset = false">tutaj</a>
      </p>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      reset: false,
      email: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    validateResetForm() {
      return !this.errors.any() && this.email !== ''
    }
  },
  methods: {
    sendResetEmail() {
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/v1/auth/send-password-reset-email', {
        email: this.email,
      }).then(response => {
        // show success message and redirect to login
        this.$vs.notify({
          title: 'message',
          text: response.data.message,
          color: 'success'
        })
        this.reset = false;
      }).catch(response => {
        // show failure message
        this.$vs.notify({
          title: 'message',
          text: response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$router.push('/moje-produkty').catch(() => {
        })

        this.$vs.notify({
          title: 'Próba logowania',
          text: 'Jesteś już zalogowany! Przekierowuję ..',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT() {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
    },
    registerUser() {
      if (!this.checkLogin()) return
      this.$router.push('/rejestracja').catch(() => {
      })
    }
  }
}

</script>

